// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ============================================================
   ContactForm — /contact page body section
   ============================================================ */

.ctform {
  background: var(--c-cream);
  padding-top: var(--section-y);
  padding-bottom: 0;
  position: relative;
  overflow: hidden;
  border-top: 1px solid var(--line);
}

.ctform__inner {
  display: flex;
  flex-direction: column;
  gap: clamp(2.5rem, 5vw, 4rem);
  position: relative;
  z-index: 1;
}

/* ══════════════════════════════════════════════════════════════
   HOW CAN WE HELP header
══════════════════════════════════════════════════════════════ */

.ctform__help-header {
  display: flex;
  align-items: center;
  gap: clamp(1rem, 2.5vw, 2rem);
}

.ctform__help-title {
  /* u-eyebrow handles type; just color */
  white-space: nowrap;
  flex-shrink: 0;
}

.ctform__help-rule {
  display: block;
  flex: 1 1;
  height: 1px;
  background: var(--line);
}

/* ══════════════════════════════════════════════════════════════
   CATEGORY CARDS — 4 equal columns
══════════════════════════════════════════════════════════════ */

.ctform__cards {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: clamp(0.75rem, 1.5vw, 1.25rem);
}

.ctform__card {
  border: 1px solid rgba(27, 27, 27, 0.14);
  border-radius: var(--radius);
  padding: clamp(1.5rem, 2.5vw, 2.25rem) clamp(1.1rem, 2vw, 1.75rem);
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: 0.75rem;
  background: var(--c-cream);
  transition:
    box-shadow 0.35s var(--ease),
    transform 0.35s var(--ease);
}

.ctform__card:hover {
  box-shadow: 0 8px 28px rgba(27, 27, 27, 0.08);
  transform: translateY(-3px);
}

/* Icon */
.ctform__card-icon {
  font-size: clamp(1.6rem, 2.8vw, 2.4rem);
  color: var(--accent);
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 0.25rem;
}

/* Label */
.ctform__card-label {
  font-family: var(--font-body);
  font-size: 0.68rem;
  font-weight: 700;
  letter-spacing: 0.22em;
  text-transform: uppercase;
  color: var(--c-ink);
  margin: 0;
}

/* Description */
.ctform__card-desc {
  font-family: var(--font-body);
  font-size: clamp(0.78rem, 1vw, 0.88rem);
  color: var(--text-muted);
  line-height: 1.6;
  margin: 0;
  flex: 1 1;
}

/* Email link */
.ctform__card-email {
  font-family: var(--font-body);
  font-size: clamp(0.7rem, 0.9vw, 0.8rem);
  font-weight: 500;
  color: var(--accent);
  text-decoration: none;
  transition: color var(--dur) var(--ease);
  word-break: break-all;
}
.ctform__card-email:hover {
  color: var(--accent-hover);
}

/* ══════════════════════════════════════════════════════════════
   LOWER TWO-COLUMN: form | contact info
══════════════════════════════════════════════════════════════ */

.ctform__lower {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: clamp(3rem, 7vw, 7rem);
  align-items: start;
  padding-bottom: clamp(2rem, 4vw, 3.5rem);
}

/* Section sub-header */
.ctform__section-header {
  display: flex;
  align-items: center;
  gap: clamp(0.75rem, 1.5vw, 1.5rem);
  margin-bottom: clamp(1.25rem, 2.5vw, 2rem);
}

.ctform__section-title {
  white-space: nowrap;
  flex-shrink: 0;
}

.ctform__section-rule {
  display: block;
  flex: 1 1;
  height: 1px;
  background: var(--line);
}

/* ── Form fields ── */
.ctform__form {
  display: flex;
  flex-direction: column;
  gap: clamp(0.75rem, 1.2vw, 1rem);
}

.ctform__row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: clamp(0.75rem, 1.2vw, 1rem);
}

.ctform__field {
  display: flex;
  flex-direction: column;
}

/* Input / textarea */
.ctform__input {
  border: 1px solid rgba(27, 27, 27, 0.22);
  border-radius: var(--radius-sm);
  background: transparent;
  padding: 0.85rem 1rem;
  font-family: var(--font-body);
  font-size: 0.72rem;
  font-weight: 600;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  color: var(--c-ink);
  outline: none;
  width: 100%;
  transition: border-color var(--dur) var(--ease);
  /* Chrome autofill override */
  -webkit-appearance: none;
}
.ctform__input::placeholder {
  color: rgba(27, 27, 27, 0.35);
  font-weight: 600;
}
.ctform__input:focus {
  border-color: var(--accent);
  box-shadow: 0 0 0 3px rgba(168, 102, 66, 0.08);
}

.ctform__textarea {
  resize: vertical;
  min-height: 160px;
  text-transform: none;
  font-size: 0.82rem;
  letter-spacing: 0.06em;
  font-weight: 400;
}
.ctform__textarea::placeholder {
  text-transform: uppercase;
  font-size: 0.72rem;
  letter-spacing: 0.14em;
}

/* Submit button */
.ctform__submit {
  background: var(--accent);
  color: var(--on-accent);
  border: none;
  border-radius: 0;
  font-family: var(--font-body);
  font-weight: 700;
  font-size: 0.72rem;
  letter-spacing: 0.22em;
  text-transform: uppercase;
  padding: 1rem 2rem;
  cursor: pointer;
  align-self: flex-start;
  transition: background var(--dur) var(--ease);
}
.ctform__submit:hover {
  background: var(--accent-hover);
}

/* Success banner */
.ctform__success {
  padding: 1.25rem 1.5rem;
  border: 1px solid var(--accent);
  border-radius: var(--radius-sm);
  background: rgba(168, 102, 66, 0.06);
}
.ctform__success p {
  font-family: var(--font-body);
  font-size: 0.9rem;
  color: var(--accent);
  margin: 0;
  font-weight: 600;
}

/* ── Contact info column ── */
.ctform__info-col {
  position: relative;
}

.ctform__info-list {
  display: flex;
  flex-direction: column;
  gap: clamp(1.25rem, 2.5vw, 2rem);
}

.ctform__info-item {
  display: flex;
  align-items: flex-start;
  gap: clamp(0.85rem, 1.5vw, 1.25rem);
}

.ctform__info-icon {
  font-size: clamp(1rem, 1.5vw, 1.25rem);
  color: var(--accent);
  flex-shrink: 0;
  margin-top: 0.1rem;
  display: flex;
}

.ctform__info-lines {
  display: flex;
  flex-direction: column;
  gap: 0.12rem;
}

.ctform__info-line {
  font-family: var(--font-body);
  font-size: clamp(0.82rem, 1vw, 0.9rem);
  color: var(--c-ink);
  display: block;
  line-height: 1.55;
}

.ctform__info-line--bold {
  font-weight: 700;
  font-size: clamp(0.85rem, 1.1vw, 0.95rem);
  letter-spacing: 0.04em;
}

.ctform__info-link {
  font-family: var(--font-body);
  font-size: clamp(0.82rem, 1vw, 0.9rem);
  color: var(--c-ink);
  text-decoration: none;
  transition: color var(--dur) var(--ease);
  display: block;
}
.ctform__info-link:hover {
  color: var(--accent);
}

/* Botanical watermark — positioned bottom-right */
.ctform__botanical {
  position: absolute;
  bottom: -2rem;
  right: -25%;
  width: clamp(200px, 24vw, 280px);
  height: auto;
  transform: rotateY(-180deg);
  color: var(--c-forest);
  opacity: 0.9;
  pointer-events: none;
}

/* ══════════════════════════════════════════════════════════════
   RESPONSIVE
══════════════════════════════════════════════════════════════ */

@media (max-width: 991.98px) {
  .ctform__cards {
    grid-template-columns: repeat(2, 1fr);
  }
  .ctform__lower {
    grid-template-columns: 1fr;
    gap: clamp(2rem, 5vw, 3.5rem);
  }
  .ctform__botanical {
    display: none;
  }
}

@media (max-width: 575.98px) {
  .ctform__cards {
    grid-template-columns: 1fr;
  }
  .ctform__row {
    grid-template-columns: 1fr;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/ContactForm.css"],"names":[],"mappings":"AAAA;;iEAEiE;;AAEjE;EACE,0BAA0B;EAC1B,6BAA6B;EAC7B,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,6BAA6B;EAC7B,kBAAkB;EAClB,UAAU;AACZ;;AAEA;;gEAEgE;;AAEhE;EACE,aAAa;EACb,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,uCAAuC;EACvC,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,SAAO;EACP,WAAW;EACX,uBAAuB;AACzB;;AAEA;;gEAEgE;;AAEhE;EACE,aAAa;EACb,qCAAqC;EACrC,mCAAmC;AACrC;;AAEA;EACE,wCAAwC;EACxC,4BAA4B;EAC5B,kEAAkE;EAClE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;EACZ,0BAA0B;EAC1B;;+BAE6B;AAC/B;;AAEA;EACE,6CAA6C;EAC7C,2BAA2B;AAC7B;;AAEA,SAAS;AACT;EACE,uCAAuC;EACvC,oBAAoB;EACpB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA,UAAU;AACV;EACE,6BAA6B;EAC7B,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,mBAAmB;EACnB,SAAS;AACX;;AAEA,gBAAgB;AAChB;EACE,6BAA6B;EAC7B,uCAAuC;EACvC,wBAAwB;EACxB,gBAAgB;EAChB,SAAS;EACT,SAAO;AACT;;AAEA,eAAe;AACf;EACE,6BAA6B;EAC7B,uCAAuC;EACvC,gBAAgB;EAChB,oBAAoB;EACpB,qBAAqB;EACrB,wCAAwC;EACxC,qBAAqB;AACvB;AACA;EACE,0BAA0B;AAC5B;;AAEA;;gEAEgE;;AAEhE;EACE,aAAa;EACb,8BAA8B;EAC9B,2BAA2B;EAC3B,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,mBAAmB;EACnB,kCAAkC;EAClC,0CAA0C;AAC5C;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,SAAO;EACP,WAAW;EACX,uBAAuB;AACzB;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,sBAAsB;EACtB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA,qBAAqB;AACrB;EACE,wCAAwC;EACxC,+BAA+B;EAC/B,uBAAuB;EACvB,qBAAqB;EACrB,6BAA6B;EAC7B,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,WAAW;EACX,+CAA+C;EAC/C,6BAA6B;EAC7B,wBAAwB;AAC1B;AACA;EACE,6BAA6B;EAC7B,gBAAgB;AAClB;AACA;EACE,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;EACpB,kBAAkB;EAClB,sBAAsB;EACtB,gBAAgB;AAClB;AACA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA,kBAAkB;AAClB;EACE,yBAAyB;EACzB,uBAAuB;EACvB,YAAY;EACZ,gBAAgB;EAChB,6BAA6B;EAC7B,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,sBAAsB;EACtB,6CAA6C;AAC/C;AACA;EACE,+BAA+B;AACjC;;AAEA,mBAAmB;AACnB;EACE,uBAAuB;EACvB,+BAA+B;EAC/B,+BAA+B;EAC/B,oCAAoC;AACtC;AACA;EACE,6BAA6B;EAC7B,iBAAiB;EACjB,oBAAoB;EACpB,SAAS;EACT,gBAAgB;AAClB;;AAEA,8BAA8B;AAC9B;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mCAAmC;AACrC;;AAEA;EACE,sCAAsC;EACtC,oBAAoB;EACpB,cAAc;EACd,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,6BAA6B;EAC7B,sCAAsC;EACtC,mBAAmB;EACnB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,yCAAyC;EACzC,sBAAsB;AACxB;;AAEA;EACE,6BAA6B;EAC7B,sCAAsC;EACtC,mBAAmB;EACnB,qBAAqB;EACrB,wCAAwC;EACxC,cAAc;AAChB;AACA;EACE,oBAAoB;AACtB;;AAEA,kDAAkD;AAClD;EACE,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,gCAAgC;EAChC,YAAY;EACZ,2BAA2B;EAC3B,sBAAsB;EACtB,YAAY;EACZ,oBAAoB;AACtB;;AAEA;;gEAEgE;;AAEhE;EACE;IACE,qCAAqC;EACvC;EACA;IACE,0BAA0B;IAC1B,6BAA6B;EAC/B;EACA;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;EACA;IACE,0BAA0B;EAC5B;AACF","sourcesContent":["/* ============================================================\n   ContactForm — /contact page body section\n   ============================================================ */\n\n.ctform {\n  background: var(--c-cream);\n  padding-top: var(--section-y);\n  padding-bottom: 0;\n  position: relative;\n  overflow: hidden;\n  border-top: 1px solid var(--line);\n}\n\n.ctform__inner {\n  display: flex;\n  flex-direction: column;\n  gap: clamp(2.5rem, 5vw, 4rem);\n  position: relative;\n  z-index: 1;\n}\n\n/* ══════════════════════════════════════════════════════════════\n   HOW CAN WE HELP header\n══════════════════════════════════════════════════════════════ */\n\n.ctform__help-header {\n  display: flex;\n  align-items: center;\n  gap: clamp(1rem, 2.5vw, 2rem);\n}\n\n.ctform__help-title {\n  /* u-eyebrow handles type; just color */\n  white-space: nowrap;\n  flex-shrink: 0;\n}\n\n.ctform__help-rule {\n  display: block;\n  flex: 1;\n  height: 1px;\n  background: var(--line);\n}\n\n/* ══════════════════════════════════════════════════════════════\n   CATEGORY CARDS — 4 equal columns\n══════════════════════════════════════════════════════════════ */\n\n.ctform__cards {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  gap: clamp(0.75rem, 1.5vw, 1.25rem);\n}\n\n.ctform__card {\n  border: 1px solid rgba(27, 27, 27, 0.14);\n  border-radius: var(--radius);\n  padding: clamp(1.5rem, 2.5vw, 2.25rem) clamp(1.1rem, 2vw, 1.75rem);\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  text-align: center;\n  gap: 0.75rem;\n  background: var(--c-cream);\n  transition:\n    box-shadow 0.35s var(--ease),\n    transform 0.35s var(--ease);\n}\n\n.ctform__card:hover {\n  box-shadow: 0 8px 28px rgba(27, 27, 27, 0.08);\n  transform: translateY(-3px);\n}\n\n/* Icon */\n.ctform__card-icon {\n  font-size: clamp(1.6rem, 2.8vw, 2.4rem);\n  color: var(--accent);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-bottom: 0.25rem;\n}\n\n/* Label */\n.ctform__card-label {\n  font-family: var(--font-body);\n  font-size: 0.68rem;\n  font-weight: 700;\n  letter-spacing: 0.22em;\n  text-transform: uppercase;\n  color: var(--c-ink);\n  margin: 0;\n}\n\n/* Description */\n.ctform__card-desc {\n  font-family: var(--font-body);\n  font-size: clamp(0.78rem, 1vw, 0.88rem);\n  color: var(--text-muted);\n  line-height: 1.6;\n  margin: 0;\n  flex: 1;\n}\n\n/* Email link */\n.ctform__card-email {\n  font-family: var(--font-body);\n  font-size: clamp(0.7rem, 0.9vw, 0.8rem);\n  font-weight: 500;\n  color: var(--accent);\n  text-decoration: none;\n  transition: color var(--dur) var(--ease);\n  word-break: break-all;\n}\n.ctform__card-email:hover {\n  color: var(--accent-hover);\n}\n\n/* ══════════════════════════════════════════════════════════════\n   LOWER TWO-COLUMN: form | contact info\n══════════════════════════════════════════════════════════════ */\n\n.ctform__lower {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: clamp(3rem, 7vw, 7rem);\n  align-items: start;\n  padding-bottom: clamp(2rem, 4vw, 3.5rem);\n}\n\n/* Section sub-header */\n.ctform__section-header {\n  display: flex;\n  align-items: center;\n  gap: clamp(0.75rem, 1.5vw, 1.5rem);\n  margin-bottom: clamp(1.25rem, 2.5vw, 2rem);\n}\n\n.ctform__section-title {\n  white-space: nowrap;\n  flex-shrink: 0;\n}\n\n.ctform__section-rule {\n  display: block;\n  flex: 1;\n  height: 1px;\n  background: var(--line);\n}\n\n/* ── Form fields ── */\n.ctform__form {\n  display: flex;\n  flex-direction: column;\n  gap: clamp(0.75rem, 1.2vw, 1rem);\n}\n\n.ctform__row {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: clamp(0.75rem, 1.2vw, 1rem);\n}\n\n.ctform__field {\n  display: flex;\n  flex-direction: column;\n}\n\n/* Input / textarea */\n.ctform__input {\n  border: 1px solid rgba(27, 27, 27, 0.22);\n  border-radius: var(--radius-sm);\n  background: transparent;\n  padding: 0.85rem 1rem;\n  font-family: var(--font-body);\n  font-size: 0.72rem;\n  font-weight: 600;\n  letter-spacing: 0.14em;\n  text-transform: uppercase;\n  color: var(--c-ink);\n  outline: none;\n  width: 100%;\n  transition: border-color var(--dur) var(--ease);\n  /* Chrome autofill override */\n  -webkit-appearance: none;\n}\n.ctform__input::placeholder {\n  color: rgba(27, 27, 27, 0.35);\n  font-weight: 600;\n}\n.ctform__input:focus {\n  border-color: var(--accent);\n  box-shadow: 0 0 0 3px rgba(168, 102, 66, 0.08);\n}\n\n.ctform__textarea {\n  resize: vertical;\n  min-height: 160px;\n  text-transform: none;\n  font-size: 0.82rem;\n  letter-spacing: 0.06em;\n  font-weight: 400;\n}\n.ctform__textarea::placeholder {\n  text-transform: uppercase;\n  font-size: 0.72rem;\n  letter-spacing: 0.14em;\n}\n\n/* Submit button */\n.ctform__submit {\n  background: var(--accent);\n  color: var(--on-accent);\n  border: none;\n  border-radius: 0;\n  font-family: var(--font-body);\n  font-weight: 700;\n  font-size: 0.72rem;\n  letter-spacing: 0.22em;\n  text-transform: uppercase;\n  padding: 1rem 2rem;\n  cursor: pointer;\n  align-self: flex-start;\n  transition: background var(--dur) var(--ease);\n}\n.ctform__submit:hover {\n  background: var(--accent-hover);\n}\n\n/* Success banner */\n.ctform__success {\n  padding: 1.25rem 1.5rem;\n  border: 1px solid var(--accent);\n  border-radius: var(--radius-sm);\n  background: rgba(168, 102, 66, 0.06);\n}\n.ctform__success p {\n  font-family: var(--font-body);\n  font-size: 0.9rem;\n  color: var(--accent);\n  margin: 0;\n  font-weight: 600;\n}\n\n/* ── Contact info column ── */\n.ctform__info-col {\n  position: relative;\n}\n\n.ctform__info-list {\n  display: flex;\n  flex-direction: column;\n  gap: clamp(1.25rem, 2.5vw, 2rem);\n}\n\n.ctform__info-item {\n  display: flex;\n  align-items: flex-start;\n  gap: clamp(0.85rem, 1.5vw, 1.25rem);\n}\n\n.ctform__info-icon {\n  font-size: clamp(1rem, 1.5vw, 1.25rem);\n  color: var(--accent);\n  flex-shrink: 0;\n  margin-top: 0.1rem;\n  display: flex;\n}\n\n.ctform__info-lines {\n  display: flex;\n  flex-direction: column;\n  gap: 0.12rem;\n}\n\n.ctform__info-line {\n  font-family: var(--font-body);\n  font-size: clamp(0.82rem, 1vw, 0.9rem);\n  color: var(--c-ink);\n  display: block;\n  line-height: 1.55;\n}\n\n.ctform__info-line--bold {\n  font-weight: 700;\n  font-size: clamp(0.85rem, 1.1vw, 0.95rem);\n  letter-spacing: 0.04em;\n}\n\n.ctform__info-link {\n  font-family: var(--font-body);\n  font-size: clamp(0.82rem, 1vw, 0.9rem);\n  color: var(--c-ink);\n  text-decoration: none;\n  transition: color var(--dur) var(--ease);\n  display: block;\n}\n.ctform__info-link:hover {\n  color: var(--accent);\n}\n\n/* Botanical watermark — positioned bottom-right */\n.ctform__botanical {\n  position: absolute;\n  bottom: -2rem;\n  right: -25%;\n  width: clamp(200px, 24vw, 280px);\n  height: auto;\n  transform: rotateY(-180deg);\n  color: var(--c-forest);\n  opacity: 0.9;\n  pointer-events: none;\n}\n\n/* ══════════════════════════════════════════════════════════════\n   RESPONSIVE\n══════════════════════════════════════════════════════════════ */\n\n@media (max-width: 991.98px) {\n  .ctform__cards {\n    grid-template-columns: repeat(2, 1fr);\n  }\n  .ctform__lower {\n    grid-template-columns: 1fr;\n    gap: clamp(2rem, 5vw, 3.5rem);\n  }\n  .ctform__botanical {\n    display: none;\n  }\n}\n\n@media (max-width: 575.98px) {\n  .ctform__cards {\n    grid-template-columns: 1fr;\n  }\n  .ctform__row {\n    grid-template-columns: 1fr;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
